<template>
    <div v-if="ready" class="table-responsive">
        <table class="table ">
            <thead>
                <tr>
                    <th class="bg-primary text-white">Indicadores</th>
                    <th v-for="(asesor, index) in asesores" :key="index">
                        {{ asesor.first_name }} {{ asesor.last_name }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="bg-light fw-bold">Calidad de la Cartera</td>
                    <td v-for="(asesor, index) in asesores" :key="index">
                        <!-- Aquí se accede directamente al valor -->
                        {{ this.calidadCartera(dashboardDataPorAsesor[asesor.id]) }}
                    </td>
                </tr>
                <tr>
                    <td class="bg-light fw-bold">Tasa de Interes Vencido</td>
                    <td v-for="(asesor, index) in asesores" :key="index">
                        <!-- Aquí se accede directamente al valor -->
                        {{ this.InteresVencido(dashboardDataPorAsesor[asesor.id]) }}
                    </td>
                </tr>
                <tr>
                    <td class="bg-light fw-bold">Tasa de Incumplimiento</td>
                    <td v-for="(asesor, index) in asesores" :key="index">
                        <!-- Aquí se accede directamente al valor -->
                        {{ this.Incumplimiento(dashboardDataPorAsesor[asesor.id]) }}
                    </td>
                </tr>
                <tr>
                    <td class="bg-light fw-bold">Rendimiento de Cartera</td>
                    <td v-for="(asesor, index) in asesores" :key="index">
                        <!-- Aquí se accede directamente al valor -->
                        {{ this.rendimientoCartera(dashboardDataPorAsesor[asesor.id]) }}
                    </td>
                </tr>
                <tr>
                    <td class="bg-light fw-bold">Rotación de Cartera</td>
                    <td v-for="(asesor, index) in asesores" :key="index">
                        <!-- Aquí se accede directamente al valor -->
                        {{ this.rotacionCartera(dashboardDataPorAsesor[asesor.id]) }}
                    </td>
                </tr>
                <tr class="table-dark">
                    <td class="fw-bold">Creditos Activos</td>
                    <td v-for="(asesor, index) in asesores" :key="index">
                        <!-- Aquí se accede directamente al valor -->
                        {{ this.carteraActiva(dashboardDataPorAsesor[asesor.id]) }}

                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div v-else>
        <p>Cargando datos...</p>
    </div>
</template>

<script>
import Security from '../security';

export default {
    name: 'TablaIndicadores',
    props: {
        asesores: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            dashboardDataPorAsesor: {}, // usar objeto tipo mapa
            ready: false,
            saldoInicial: (112320640.5 + 2267699.49),

        };
    },
    mounted() {
        // Ejecutar todos los fetch y esperar que terminen
        const promesas = this.asesores.map(asesor =>
            this.obtenerDashboardData('ALL', asesor.id)
        );

        Promise.all(promesas).then(() => {
            this.ready = true;
        });
    },
    methods: {
        async obtenerDashboardData(sucursal, asesorId) {
            return fetch(process.env.VUE_APP_API_URL + "/admin/credito/dashboard-data",
                Security.requestOptions({ sucursal, asesor: asesorId }))
                .then((response) => response.json())
                .then((response) => {
                    if (response.error) {
                        this.$emit('error', response.message);
                        console.error(response.message);
                    } else {
                        // Guardar la data por ID
                        this.dashboardDataPorAsesor[asesorId] = response.data.dashboardData;
                    }
                })
                .catch(error => {
                    this.$emit('error', error);
                    console.error("Error al obtener datos:", error);
                });
        },
        calidadCartera(data) {
            let totalSaldoRangos = (data.saldoVigente + data.saldo30Dias + data.saldo60Dias + data.saldo89Dias + data.saldoMoraContable + data.saldo150Dias  + data.saldo180Dias + data.saldo181Dias )
            return (Math.floor((data.saldoMoraContable + data.saldo89Dias + data.saldo60Dias + data.saldo150Dias + data.saldo180Dias + data.saldo181Dias) / totalSaldoRangos * 100)) + "  %"
        },
        InteresVencido(data) {
            return Math.floor(((data.saldoInteresMas30Dias / data.saldoTotalInteres) * 100).toFixed(2)) + " %"
        },
        Incumplimiento(data) {
            let noClientesRangos = (data.noVigente + data.no30Dias + data.no60Dias + data.no89Dias + data.noMoraContable + data.no150Dias  + data.no180Dias + data.no181Dias )
            return Math.floor(((data.noInteresMas30Dias / noClientesRangos) * 100).toFixed(2)) + " %"
        },
        rendimientoCartera(data) {
            let totalSaldoRangos = (data.saldoVigente + data.saldo30Dias + data.saldo60Dias + data.saldo89Dias + data.saldoMoraContable + data.saldo150Dias  + data.saldo180Dias + data.saldo181Dias )

            return ((data.interesPagosMesHoy / ((this.saldoInicial + totalSaldoRangos) / 2)) * 100).toFixed(2) + " %"
        },
        rotacionCartera(data) {
            let totalSaldoRangos = (data.saldoVigente + data.saldo30Dias + data.saldo60Dias + data.saldo89Dias + data.saldoMoraContable + data.saldo150Dias  + data.saldo180Dias + data.saldo181Dias )

            return ((data.montoPagosHoyMesHoy / ((this.saldoInicial + totalSaldoRangos) / 2)) * 100).toFixed(2) + " %"
        },
        carteraActiva(data) {
            return data.noActivos + data.noVencidos + data.noLegal
        }
    },
};
</script>
